import { Button } from 'primereact/button';
import React from 'react';
import './group-buttom.scss';


const GroupButtom = ({onTestClick, onWhatsClick, column}) =>{
    return(
        <div className={`group-buttom-conteiner ${column? 'group-buttom-flex-direction-column':''}`}>
            <div className="group-buttom-conteiner-item">
                <Button label={<div className="button-schedule-whatss">Agendar teste</div>} className='p-button-rounded button-blue p-button-lg' 
                    // onClick={ ()=> { window.open( api.addresses.covidTest.whatssApp,'_blank')}}
                onClick={ onTestClick } 
                style={{marginBottom:'5px'}}/>
            </div>
            <div className="group-buttom-conteiner-item">
                <Button label={<div className="button-schedule-whatss">Agendar pelo WhatsApp</div>} onClick={ onWhatsClick } className='p-button-rounded p-button-lg p-button-outlined' />
            </div>
        </div>
    ) 
}

export default GroupButtom